export default {
  BROWSE_ITEMS: '/items',
  BROWSE_SETS: '/sets',
  BROWSE_SETS_BY_NAME: '/sets/byName',
  BROWSE_PROJECTS_BY_NAME: '/projects/byName',
  BROWSE_CATEGORIES_BY_NAME: '/categories/byName',
  BROWSE_TAGS_BY_NAME: '/tags/byName',
  BROWSE_STORAGES_BY_NAME: '/storages/byName',
  BROWSE_MANUFACTURERS_BY_NAME: '/manufacturers/byName',
  WISHLIST_ITEMS: '/wishlist-items',
  PROJECT_ITEMS: '/project-items',
  WISHLIST: '/wishlist',
  PROJECTS: '/projects',
  CATEGORIES: '/categories',
  USER_CATEGORIES: '/categories/user',
  ITEMS_CATEGORIES: '/categories/items',
  USERS: '/user',
  MANUFACTURERS: '/manufacturers',
  STORAGES: '/storages',
  SEARCH_ITEMS: '/items/search',
  SET_ITEMS: '/set-items',
  TAGS: '/tags',
  HISTORY: '/history',
  IMAGES: '/images',
  IMAGES_URL: '/images/url',
  LOGIN: '/auth/login',
  BARCODE_ITEMS: '/barcodes',
  BARCODE_ITEMS_VALIDATE: '/barcodes/exists',
  BARCODE_ITEMS_SEARCH: '/barcodes/search',
  BARCODE_CATEGORIES: '/barcodes/categories',
  BARCODE_MANUFACTURERS: '/barcodes/manufacturers',
  VERSION: '/version',
};
